import { createRoot } from 'react-dom/client'
import { configResponsive } from 'ahooks'
import RootApp from './App'
import { ScreenSize } from '@/constants'

import * as Sentry from '@sentry/react'

if (import.meta.env.VITE_APP_SENTRY_DSN) {
  Sentry.init({
    // DSN (Data Source Name): Sentry 项目的唯一标识符，告诉 SDK 将事件发送到哪里
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,

    // 集成插件配置
    integrations: [
      // 浏览器性能追踪：自动捕获页面加载、路由跳转等性能数据
      Sentry.browserTracingIntegration(),
      // 会话重放：录制用户操作视频，帮助复现难以定位的 bug
      Sentry.replayIntegration(),
    ],

    // 运行环境：区分开发(development)、测试(test)、生产(production)等环境
    environment: import.meta.env.MODE,

    // 性能追踪采样率 (0.0 - 1.0)
    // 1.0 表示 100% 采集，生产环境建议调低（如 0.1 或 0.2）以控制成本和性能影响
    tracesSampleRate: 0.2,

    // 会话重放采样率 (0.0 - 1.0)
    // sessionSampleRate: 正常会话的采样率，生产环境建议较低（如 0.1）
    replaysSessionSampleRate: 0,
    // errorSampleRate: 发生错误时的会话采样率，建议设为 1.0，确保所有报错都能看到回放
    replaysOnErrorSampleRate: 1.0,

    // 是否发送默认的个人身份信息 (PII)
    // 开启后会收集 IP 地址、User-Agent 等，需注意隐私合规
    sendDefaultPii: true,

    // 忽略特定的错误信息
    // 可以过滤掉一些无关紧要的报错，减少噪音
    ignoreErrors: [
      'ResizeObserver loop limit exceeded', // 常见的浏览器良性错误
      'Network Error', // 网络错误通常无法通过代码修复
    ],

    // 发布版本号
    // 建议在构建时通过环境变量注入，用于关联 Source Maps 和 Issue
    // release: import.meta.env.VITE_APP_VERSION || '0.0.1',
  })
}

configResponsive({
  xs: ScreenSize.xs,
  sm: ScreenSize.sm,
  md: ScreenSize.md,
  lg: ScreenSize.lg,
  xl: ScreenSize.xl,
})

createRoot(document.getElementById('root') as HTMLElement).render(
  <Sentry.ErrorBoundary>
    <RootApp />
  </Sentry.ErrorBoundary>,
)

if (!Object.hasOwn) {
  Object.hasOwn = (obj, prop) => Object.hasOwn(obj, prop)
}
